import { useCallback, useMemo, useState } from 'react';
import { getFingerprint } from '@shootsta/client-auth';
import { useUpdateEffect } from 'react-use';
import { useApi } from '../../../ui-kit';






export const useSocialAuthButtonListContextValue = (
{
  loginSocial,
  alias,
  onSuccess,
  onError
}) =>
{
  const [socialAuthData, setSocialAuthData] = useState();

  const { data: loginSocialData, error: loginSocialError } = useApi({
    dataBasePath: 'loginSocial',
    shouldLoadInitially: false,
    fn: async () => {
      if (!socialAuthData) {
        // $FlowFixMe
        return null;
      }

      const fingerprint = await getFingerprint();
      // $FlowFixMe
      return loginSocial({ fingerprint, alias, ...socialAuthData });
    }
  }, [socialAuthData, alias]);

  const onAuthSuccess = useCallback((data) => {
    setSocialAuthData(data);
  }, []);

  const onAuthError = useCallback((data) => {
    // Social login modals show their own errors
    // For now we don't need them
    // eslint-disable-next-line no-console
    console.log('on Auth error', data);
  }, []);

  useUpdateEffect(() => {
    if (!loginSocialData || !socialAuthData) {
      return;
    }

    onSuccess({
      userAuthData: loginSocialData,
      socialAuthData
    });
  }, [loginSocialData, socialAuthData]);

  useUpdateEffect(() => {
    if (loginSocialError) {
      onError(loginSocialError);
    }
  }, [loginSocialError, onError]);

  return useMemo(() => ({
    onAuthSuccess,
    onAuthError
  }), [
  onAuthSuccess,
  onAuthError]
  );
};